import React from 'react';
import { Incident, IncidentStatus } from '../../pages/law/incidentsData';
import { DashboardIcon } from '../ui/DashboardIcon';
import { DetailList } from '../ui/DetailList';

type IncidentDialogProps = {
  incident: Incident;
  onClose: () => void;
  onUpdateStatus: (id: string, status: IncidentStatus) => void;
};

export function IncidentDialog({ incident, onClose, onUpdateStatus }: IncidentDialogProps) {
  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={onClose}>
      <section
        aria-labelledby="incident-dialog-title"
        aria-modal="true"
        className="incident-dialog"
        role="dialog"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header className="incident-dialog-head">
          <h2 id="incident-dialog-title">Incident {incident.id}</h2>
          <button className="btn-icon borderless" type="button" aria-label="Close incident details" onClick={onClose}>
            <DashboardIcon type="close" />
          </button>
        </header>

        <div className="incident-dialog-body">
          <div className={`incident-status-banner ${incident.status}`}>
            Status: {incident.status.toUpperCase()}
          </div>
          <DetailList
            items={[
              { label: 'Passenger', value: incident.passenger },
              { label: 'Vehicle', value: <code>{incident.vehicle}</code> },
              {
                label: 'Location',
                value: (
                  <a href={`https://maps.google.com/?q=${incident.lat},${incident.lng}`} target="_blank" rel="noreferrer">
                    {incident.lat.toFixed(4)}, {incident.lng.toFixed(4)}
                  </a>
                ),
              },
              { label: 'Note', value: incident.note },
            ]}
          />

          {incident.status !== 'resolved' ? (
            <div className="form-group">
              <label htmlFor="resolution-notes">Resolution notes</label>
              <textarea id="resolution-notes" placeholder="What happened? How was it resolved?" />
            </div>
          ) : null}
        </div>

        <footer className="incident-dialog-actions">
          <button className="btn" type="button" onClick={onClose}>
            {incident.status === 'resolved' ? 'Close' : 'Cancel'}
          </button>
          {incident.status === 'active' ? (
            <button className="btn" type="button" onClick={() => onUpdateStatus(incident.id, 'acknowledged')}>
              Acknowledge
            </button>
          ) : null}
          {incident.status !== 'resolved' ? (
            <button className="btn btn-primary" type="button" onClick={() => onUpdateStatus(incident.id, 'resolved')}>
              Mark resolved
            </button>
          ) : null}
        </footer>
      </section>
    </div>
  );
}
